/*
 * @Date: 2023-08-18 16:47:15
 * @Description: 路由守卫
 */
import Cookies from 'js-cookie'
import GlobalModal from '@/components/widget/GloabModal'
import { Whitelist } from './utils'

type IAuthLoginProps = {
  children: React.ReactNode
}

const AuthLogin = (props: IAuthLoginProps) => {
  const { getSellerInfo, sellerInfo } = useSellerInfoStore()
  const { getUserInfo, userInfo, loginOut } = useUserInfoStore()
  const [visible, setVisible] = useState(false)
  /** 跳转至登录页 */
  const location = useLocation()
  /** 跳转至登录页 */
  const isToLogin = window.location.pathname?.includes('/login')
  /* 通用白名单 */
  const isWhitelist = Whitelist?.includes(window.location.pathname)
  /* 通用页面 */
  const GeneralPage = !isWhitelist && !isToLogin
  useLayoutEffect(() => {
    ;(async () => {
      try {
        if (Cookies.get('token') && !isToLogin && !userInfo?.uid) {
          // 获取用户信息
          await getUserInfo()
          // 获取商家信息
          await getSellerInfo()
        }
      } catch (error) {
        // 报错直接退出登录
        loginOut()
      } finally {
        setVisible(true)
      }
    })()
  }, [])
  return visible ? (
    <>
      {!userInfo?.uid && !isToLogin ? (
        <Navigate to={`/login${location.search}`} state={{ from: location }} replace={true} />
      ) : !sellerInfo?.shortName && GeneralPage && userInfo?.seller?.is_main ? (
        <>
          <Navigate to={'/improve-account'} state={{ from: location }} replace={true} />
        </>
      ) : (
        <>
          {GeneralPage && <GlobalModal.Active618 />}
          {props.children}
        </>
      )}
    </>
  ) : null
}

export default AuthLogin
